// C3b · REMOVED per Constitutional Refactor. Null stub retained
// only so retired hub pages continue to parse.
const Removed = () => null;
export default Removed;
export const AppNotificationsBell = Removed;
export const CommunityNotificationsBell = Removed;
export const UpgradePrompt = Removed;
export const WelcomeTour = Removed;
export const NPSPrompt = Removed;
export const InstallAppPrompt = Removed;
export const OpportunityPrompts = Removed;
export const GrowthGoalsPrompt = Removed;
export const FounderModeBanner = Removed;
export const WelcomeFromJohn = Removed;
export const UpcomingSessionNudge = Removed;
export const SessionRemindersBanner = Removed;
